import React, { useContext } from 'react';
import { navigate } from '@reach/router';
import { KeyboardArrowLeftIcon } from 'react-magma-icons';
import { StyledBackLink } from '../Styled';
import { EditToolContext } from '../../contexts/editToolContext';

interface IBackLink {
  collection: string;
  backTo: string;
}

export const BackLink: React.FC<IBackLink> = (props): JSX.Element => {
  const { collection, backTo } = props;

  const { handleLeavePage } = useContext(EditToolContext);

  return (
    <StyledBackLink
      onClick={e => handleLeavePage(() => navigate(backTo), false, e)}
      data-testid="back-link"
      to={backTo}
      aria-label={`Back to ${collection}`}
    >
      <KeyboardArrowLeftIcon />
      {collection}:
    </StyledBackLink>
  );
};
